export default {
    blue: '#3974F2',
    red: '#BE89AB',
    fredningsRed: '#ED5151',
    fredningsYellow: '#FFFFBF',
    fredningsBlue: '#0070FF',
}